import { render } from "./SaintOfTheDay.vue?vue&type=template&id=4ae3a1cb&scoped=true"
import script from "./SaintOfTheDay.vue?vue&type=script&lang=js"
export * from "./SaintOfTheDay.vue?vue&type=script&lang=js"

import "./SaintOfTheDay.vue?vue&type=style&index=0&id=4ae3a1cb&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ic-lab/ic-lab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ae3a1cb"]])

export default __exports__